import { useTranslation } from 'react-i18next';

import useBusinessHours from '@/hooks/useBusinessHours';
import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import useMembers from '@/hooks/useMembers';
import { languageCodes } from '@/shared/languageCodes';
import { COUNTRIES_VALUE_TO_LABEL } from '@/util/countries';
import { timezoneMaker } from '@/util/geography';

import { ConditionInputType, STATUS_LABEL_KEYS } from './constants';

const AgentName = ({ value }: { value: string }) => {
  const { getMember } = useMembers();
  return <>{getMember(value)?.name ?? value}</>;
};

const IntegrationName = ({ value }: { value: string }) => {
  const deskId = useDeskId();
  const { integrations } = useIntegrations(deskId);
  const integration = integrations?.find(({ integration_id }) => integration_id === value);
  return <>{integration?.name ?? value}</>;
};

const BusinessHoursName = ({ value }: { value: string }) => {
  const { businessHours } = useBusinessHours();
  const match = businessHours?.business_hours.find(
    ({ business_hours_id }) => business_hours_id === value
  );
  return <>{match?.name ?? value}</>;
};

type ConditionValueLabelProps = { input: ConditionInputType; value: string };

export const ConditionValueLabel = ({ input, value }: ConditionValueLabelProps) => {
  const { t } = useTranslation();

  switch (input) {
    case 'language':
      return <>{languageCodes[value] ?? value}</>;
    case 'country':
      return <>{COUNTRIES_VALUE_TO_LABEL[value] ?? value}</>;
    case 'timezone':
      return <>{timezoneMaker([value])[0]?.label ?? value}</>;
    case 'agent':
      return <AgentName value={value} />;
    case 'integration':
      return <IntegrationName value={value} />;
    case 'business_hours':
      return <BusinessHoursName value={value} />;
    case 'status':
      return <>{STATUS_LABEL_KEYS[value] ? t(STATUS_LABEL_KEYS[value]) : value}</>;
    default:
      return <>{value}</>;
  }
};
